<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" type="radio" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="datetime" label="付款时间" start-name="begin_time" end-name="end_time"></c-form-item>
					<c-form-item type="select" label="结算状态" name="state" :options="state" ></c-form-item>
				</c-form>
			</m-search>
            <m-operate>
                <c-button color="m" hollow @click="syncExport()">导出</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>
			<c-table ref="table">
				<c-table-column
					label="支付时间"
					name="payment_date"
					width="150"
				></c-table-column>

				<c-table-column
					label="订单号"
					name="order_number"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="商家名称"
					name="stationed_name"
					width="160"
				></c-table-column>

				<c-table-column
					label="订单类型"
					name="order_type"
					width="100"
				>
					<template v-slot="{data}">
						<span>{{orderTypeName[data.order_type]}}</span>
					</template>
				</c-table-column>

				<c-table-column
					label="商品数量"
					name="product_count"
					width="80"
				>
				</c-table-column>

				<c-table-column
					label="商品金额"
					name="product_money"
					width="120"
				>
					<template v-slot="row">
					    {{'¥'+parseFloat(row.data.product_money).toFixed(2)}}
					</template>
				</c-table-column>

				<c-table-column
					label="订单运费"
					name="logistics_money"
					width="120"
				>
					<template v-slot="row">
						{{'¥'+parseFloat(row.data.logistics_money).toFixed(2)}}
					</template>
				</c-table-column>

				<c-table-column
					label="其他费用"
					name="other_fee"
					width="120"
				>
					<template v-slot="row">
						<span v-if="row.data.other_fee && row.data.other_fee > 0" style="color:#ff00ff">
							{{'¥'+parseFloat(row.data.other_fee).toFixed(2)}}
						</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="结算状态"
					name="state"
					width="75"
				>
					<template v-slot="{data}">
						<span v-if="data.state==1" style="color:darkgray">{{transStateName[data.state]}}</span>
						<span v-if="data.state==2" style="color:brown">{{transStateName[data.state]}}</span>
						<span v-if="data.state==3" style="color:darkgreen">{{transStateName[data.state]}}</span>
						<span v-if="data.state==4" style="color:red">{{transStateName[data.state]}}</span>
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="70"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/settlement/detail/${data.order_number}`)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
    import axios from 'axios';
    export default {
		name: 'm_order_settlement',
		
		components: {
			stationedSelector
		},
		
		computed: {
            ...mapState(['systemConfig', 'userInfo']),
		},
		
		data() {
			return {
          workType:1,//业务类型，详见枚举【ExportTypeEnum】
          searchParams:{},
          operationMode: [
              {name: '平台自营',value: 1},
              {name: '商家自营',value: 2},
              {name: '采购供货',value: 3}
          ],
          transStateName: {
              1: '待结算',
              2: '部分结算',
              3: '全部结算',
              4: '取消结算'
          },
          state: [
              {name: '待结算',value: 1},
              {name: '部分结算',value: 2},
              {name: '全部结算',value: 3},
              {name: '取消结算',value: 4}
          ],
          orderTypeName: {
              1: '普通',
              2: '积分',
              3: '赠品',
              4: '砍价',
              5: '全款预售',
              6: '定金预定',
              7: '定制',
              8: '拼团',
              9: '云仓提货',
              10: '送礼',
              11: '抽奖'
          }
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/order/settlement/list',
					data
				});
                this.searchParams = data||{};
            },
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>